module.exports = __webpack_public_path__ + "static/media/ultra-main-logo.0ff97630.png";